import hero from "@/assets/hero-verhuizers.jpg";
import teamAsset from "@/assets/wagenpark-vakkundig.jpg.asset.json";
import opslagAsset from "@/assets/opslag-ruimte-vakkundig.jpeg.asset.json";
import seniorenAsset from "@/assets/senioren-seal-full.jpg.asset.json";
import dozenAsset from "@/assets/foto-dozen-rollers.jpg.asset.json";
import zakelijkAsset from "@/assets/zakelijke-verhuizing-kantoorinventaris.jpeg.asset.json";
import liftAsset from "@/assets/foto-lift-appartement.jpg.asset.json";
import particulierAsset from "@/assets/foto-particulier-wagens.jpg.asset.json";
import evenementAsset from "@/assets/evenementen-zaal-congres.jpg.asset.json";
import inpakkenAsset from "@/assets/inpakservice-home.jpg.asset.json";
import ontruimingAsset from "@/assets/foto-ontruiming-container.jpg.asset.json";

export const images = {
  hero,
  team: teamAsset.url,
  opslag: opslagAsset.url,
  senioren: seniorenAsset.url,
  inpakken: inpakkenAsset.url,
  zakelijk: zakelijkAsset.url,
  particulier: particulierAsset.url,
  evenementen: evenementAsset.url,
  verhuislift: liftAsset.url,
  dozen: dozenAsset.url,
  ontruiming: ontruimingAsset.url,
};

export type ImageKey = keyof typeof images;
